import Request from 'api/Request';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<{}>>;

const forgotPassword = (username: string): ReturnType => {
    return Request.post(`/authentication/password/request-reset`, { user_name: username });
};
export default forgotPassword;
